import bottomCurve from "planets/racion/bottom-curve"
import trail from "planets/racion/trail"
import {
  PlanetHorizon,
  ShortPlanetHorizon,
  PlanetHorizonContainer,
  ShortPlanetHorizonContainer,
  PlanetHorizonTitle
} from "planets/racion/horizon"
import editProfileBackground from "planets/racion/racion-edit-profile-stones.svg"

export default {
  mainColor: "#8e3fac",
  secondaryColor: "#ff8cba",
  bottomCurve: bottomCurve,
  trail: trail,
  knowledgeAreaSlide: { prev: "#cc63f1", next: "#ff2ec3" },
  dailyMission: {
    questionSlider: { prev: "#5fc8db", next: "#ff8cba", arrowColor: "#fff" }
  },
  btnPrimary: { backgroundColor: "#ff9229", textColor: "#fff", shadowColor: "#ce6d10" },
  btnLink: { backgroundColor: "#8e3fac", activeTextColor: "#ff9229" },
  gamificationBar: {
    white: { textColor: "#8e3fac" },
    colored: { textColor: "#fff" }
  },
  header: { colored: { backgroundColor: "#8e3fac" } },
  horizon: {
    PlanetHorizon,
    ShortPlanetHorizon,
    PlanetHorizonContainer,
    ShortPlanetHorizonContainer,
    PlanetHorizonTitle
  },
  editProfileBackground: editProfileBackground,
  games: {
    title: "#8e3fac",
    border: "#8e3fac",
    detailsHeader: "#ff8cba"
  }
}
